import React, { useState } from "react";
import Functions from "../../src/functions";
import { Link } from "react-router-dom";

function Mapper(data, status, response, error, component) {
	let output = [];
	let UserType = Functions["custom"]["getUserType"]();
	if (data) {
		data.forEach((itm) => {
			let property = {};

			property["data"] = itm;
			if (itm.bundle === "99999999") {
				property["teaser"] = itm.busServiceDes;
				sessionStorage.setItem("busServiceDes", itm.busServiceDes);
			} else if (
				!(
					UserType === "POSTB" ||
					UserType === "POSTB_SPLIT" ||
					UserType === "POSTR"
				)
			) {
				property["teaser"] = itm.mtbSubtitle
					? itm.mtbSubtitle
					: itm.busServiceDes;
				property["busServiceDes"] = itm.busServiceDes;
				sessionStorage.setItem("busServiceDes", itm.busServiceDes);
			} else {
				property["teaser"] = itm.teaser;
				sessionStorage.setItem("busServiceDes", itm.busServiceDes);
			}
			if (
				UserType === "POSTB" ||
				UserType === "POSTB_SPLIT" ||
				UserType === "POSTR"
			) {
				sessionStorage.setItem("groupId", itm.purchaseOptions.purchaseGroup);
				sessionStorage.setItem("id", itm.jointID);
			}
			property["period"] = itm.period;
			property["periodMeasunit"] = itm.periodMeasunit;
			property["tariff"] = itm.tariff;
			sessionStorage.setItem("amount", itm.tariff);
			property["id"] = itm.id;

			output.push(property);
		});
	}

	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		id: {
			alias: "id",
			type: "text",
			editable,
		},
		period: {
			alias: "period",
			type: "text",
			editable: false,
		},
		busServiceDes: {
			alias: "busServiceDes",
			type: "text",
			editable: false,
		},
		periodMeasunit: {
			alias: "periodMeasunit",
			type: "text",
			editable: false,
		},
		tariff: {
			alias: "tariff",
			type: "text",
			editable,
		},
		data: {
			alias: "data",
			type: "hidden",
			editable,
		},
		teaser: {
			alias: "teaser",
			type: "text",
			editable,
		},
		confirm: {
			alias: "confirm",
			type: "button",
			caption: "Επιβεβαίωση",
			events: {
				onClick: function () {
					// window.location.replace(
					//   "/creditSubmitService?id=" + this.props.data.id
					// );
				},
			},
			editable,
		},
	};
}
function submitButton(data) {
	let UserType = Functions["custom"]["getUserType"]();
	let landPageData = JSON.parse(sessionStorage.landPageData);
	let newData = data.data.data.data;
	let paymentMethod = "";

	if (
		newData?.purchaseOptions?.hasPurchaseTypes &&
		newData?.impAddOn?.data === null
	) {
		if (UserType === "POSTB" || UserType === "POSTB_SPLIT") {
			if (
				landPageData.contractInfoCarrier.restrictionType ===
					"LIMIT_ACCESS_RESTRICTION_ONLY_HOURS_PASS" ||
				landPageData.contractInfoCarrier.restrictionType ===
					"LIMIT_ACCESS_RESTRICTION_NO_PASS"
			) {
				paymentMethod = "/submitPaymentInfo";
			} else {
				paymentMethod = "/creditSubmitService";
			}
		} else if (
			(UserType === "POSTR" &&
				landPageData.contractInfoCarrier.inListOfWhatuspCss) ||
			UserType === "POSTR"
		) {
			paymentMethod = "/thank_you";
		}
	} else if (
		UserType === "PREPAID_FROG" ||
		UserType === "PREPAID_WHATSUP" ||
		UserType === "PREPAID_COSMOKARTA"
	) {
		paymentMethod = "/thank_you";
	} else if (UserType === "HYBRID_RESIDENTIAL_COST_CONTROL") {
		paymentMethod = "/thank_you";
	} else if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
		paymentMethod = "/creditSubmitService";
	}

	return paymentMethod;
}

function contentPackageOptions(data) {
	let output = [];
	let htmlEl = "";
	let UserType = Functions["custom"]["getUserType"]();
	if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
		return <></>;
	}
	let doesTheCurrentLoopServiceHasPopUp = true;
	if (data.data.data.data.modal.alreadyPurchasedAndCannotBeActivated === true) {
		doesTheCurrentLoopServiceHasPopUp = false;
	} else if (data.data.data.data.modal.disabledAndCannotBeActivated === true) {
		doesTheCurrentLoopServiceHasPopUp = false;
	}
	let modalData = data.data.data.data.modal;
	let isChecked = false;

	if (
		modalData.servicePurchaseMethodUIFormat === "MANY_PURCHASE_TYPES" &&
		doesTheCurrentLoopServiceHasPopUp
	) {
		if (UserType === "HYBRID_BUSINESS_COST_CONTROL" && modalData.inCreditFlow) {
			document.getElementsByClassName("package-options")[0].className =
				"package-options hidden";
		} else {
			output.push(<h6>Επίλεξε τον τρόπο αγοράς του πακέτου</h6>);
		}
		if (modalData.listOfAvailableTypesOfPurchase.length > 0) {
			for (
				let i = 0;
				i < modalData.listOfAvailableTypesOfPurchase.length;
				i++
			) {
				// Check if it is not an empty object
				if (modalData.listOfAvailableTypesOfPurchase[i].visibleInPortal) {
					let classname = "";
					let inputText = "";
					if (modalData.listOfAvailableTypesOfPurchase[i].eligibleInPortal) {
						if (modalData.listOfAvailableTypesOfPurchase[i].preselected) {
							// the purchase types is preselected because is the first available for purchase
							document.getElementsByClassName(
								"option customClassAddCursorPointer",
							)[0].className += " active ";
						} else {
							classname += "";
						}
					} else {
						// The purchase types already selected or not available for purchase
						if (modalData.listOfAvailableTypesOfPurchase[i].alreadyActive) {
							// already selected
							classname += " completed ";
						} else {
							// ineligible for purchase
							classname += " disabled ";
						}
					}
					if (modalData.listOfAvailableTypesOfPurchase[i].type === "BILL") {
						inputText += "Με χρέωση στον επόμενο λογαριασμό";
					} else if (
						modalData.listOfAvailableTypesOfPurchase[i].type === "BLNC"
					) {
						inputText += "Με χρέωση στο υπόλοιπο";
					} else if (
						modalData.listOfAvailableTypesOfPurchase[i].type === "RCRNT"
					) {
						inputText +=
							"Αυτόματη αγορά του πακέτου κάθε μήνα με χρέωση στο λογαριασμό";
					}

					let divText = "";

					if (!modalData.listOfAvailableTypesOfPurchase[i].eligibleInPortal) {
						// Present the following ineligiblity messages to the customer for every any purchase type in not Portal eligible
						if (
							modalData.listOfAvailableTypesOfPurchase[i]
								.reasonOfIneligibility == "NOT_ENOUGH_BALANCE"
						) {
							divText = (
								<>
									<div className="info">
										Δεν έχετε επαρκές χρηματικό υπόλοιπο
									</div>
									<span></span>
								</>
							);
						} else if (
							modalData.listOfAvailableTypesOfPurchase[i]
								.reasonOfIneligibility == "REACHED_MAX_PROVISIONED"
						) {
							divText = (
								<>
									<div className="info">Έχετε ήδη αγοράσει 3 πακέτα</div>
									<span></span>
								</>
							);
						} else if (
							modalData.listOfAvailableTypesOfPurchase[i].alreadyActive
						) {
							divText = (
								<>
									<div className="info green">
										{modalData.offerText == null ? "" : modalData.offerText}
									</div>
									<span></span>
								</>
							);
						} else if (
							modalData.listOfAvailableTypesOfPurchase[i]
								.reasonOfIneligibility === "TP_NOT_ELIGIBLE"
						) {
							divText = (
								<>
									<div className="info">Μη διαθέσιμο</div>
									<span></span>
								</>
							);
						} else {
							// for other reasons do not show any textual reason
							divText = (
								<>
									<div className="info"></div>
									<span></span>
								</>
							);
						}
					} else {
						if (modalData.listOfAvailableTypesOfPurchase[i].type === "RCRNT") {
							divText = (
								<>
									<div className="info green">
										{modalData.offerText == null ? "" : modalData.offerText}
									</div>
									<span></span>
								</>
							);
						} else {
							divText = <span></span>;
						}
					}

					htmlEl = (
						<a
							className={
								"option customClassAddCursorPointer " +
								classname +
								" customeClassPuchaseType customeClassTypeOfPuchase"
							}
							onClick={() => {
								submitButton(data);
								isChecked = true;
								let a = document.getElementsByClassName("option");
								let optionType =
									data.data.data.data.modal.listOfAvailableTypesOfPurchase[i]
										.type;
								sessionStorage.setItem("optionType", optionType);
								sessionStorage.setItem("pt", optionType);
								let numberOfOptions = a.length;
								let isDisabled = false;
								isDisabled = a[i].classList.contains("disabled");
								if (isChecked && !isDisabled) {
									a[i].className = "option active customClassAddCursorPointer ";
									for (let j = 0; j < a.length; j++) {
										if (i === j) continue;
										if (!a[j].classList.contains("disabled"))
											a[j].className = "option customClassAddCursorPointer ";
									}
									isChecked = false;
								}
							}}>
							<input
								type="radio"
								name="package-option"
								// checked={
								//   modalData.listOfAvailableTypesOfPurchase[i].preselected
								//     ? "true"
								//     : ""
								// }
								// checked={isChecked}
							/>
							{inputText}
							{divText}
						</a>
					);

					output.push(htmlEl);
				}
			}
		}
	}
	if (output.length !== 0) {
		return <div className="package-options">{output}</div>;
	} else {
		return <></>;
	}
}

function detailsOfBundles(data) {
	let output = [];
	let UserType = Functions["custom"]["getUserType"]();
	let bundle = "";
	let bundleMin = "";
	let bundleSMS = "";
	let textSMS = "";
	let textMin = "";
	let summerOfferState = false;
	let summerOfferFlag =
		summerOfferState === true && data.data.data.data.summerOfferActive;
	let doesTheCurrentLoopServiceHasPopUp = true;
	if (data.data.data.data.modal.alreadyPurchasedAndCannotBeActivated === true) {
		doesTheCurrentLoopServiceHasPopUp = false;
	} else if (data.data.data.data.modal.disabledAndCannotBeActivated === true) {
		doesTheCurrentLoopServiceHasPopUp = false;
	}
	if (
		!(UserType == "POSTB" || UserType === "POSTB_SPLIT" || UserType === "POSTR")
	) {
		if (data.data.data.data.offerList.length !== 0) {
			data.data.data.data.offerList.map((itm, idx) => {
				let isTheDetailsSMSfirstLabelInserted = false;
				let isTheDetailsMINfirstLabelInserted = false;
				if (
					(data.data.data.data.modal.servicePurchaseMethodUIFormat ===
						"ONLY_ONE_PURCHASE_TYPE_BLNC" ||
						data.data.data.data.modal.servicePurchaseMethodUIFormat ===
							"MANY_PURCHASE_TYPES") &&
					doesTheCurrentLoopServiceHasPopUp
				) {
					if (itm.type === "GPRS") {
						if (
							UserType === "PREPAID_FROG" ||
							UserType === "PREPAID_COSMOKARTA" ||
							UserType === "PREPAID_WHATSUP"
						) {
							if (data.data.data.data.modal.type === "CHAT") {
								bundle = (
									<div className="row">
										<div className="col l">Chat:</div>
										<div className="col r">
											{itm.bundle === "99999999" ? "Unlimited" : itm.bundle}{" "}
											{itm.bundleMeasUnit}{" "}
											{data.data.data.data.type === "OTE_TV"
												? " για COSMOTE TV GO"
												: ""}
										</div>
										<div className="clear"></div>
									</div>
								);
							} else if (data.data.data.data.modal.type === "PLAY") {
								bundle = (
									<div className="row">
										<div className="col l">Streaming:</div>
										<div className="col r">
											{itm.bundle === "99999999" ? "Unlimited" : itm.bundle}{" "}
											{itm.bundleMeasUnit}{" "}
											{data.data.data.data.type === "OTE_TV"
												? " για COSMOTE TV GO"
												: ""}
										</div>
										<div className="clear"></div>
									</div>
								);
							} else if (data.data.data.data.modal.type === "SOCIAL") {
								bundle = (
									<div className="row">
										<div className="col l">Social:</div>
										<div className="col r">
											{itm.bundle === "99999999" ? "Unlimited" : itm.bundle}{" "}
											{itm.bundleMeasUnit}{" "}
											{data.data.data.data.type === "OTE_TV"
												? " για COSMOTE TV GO"
												: ""}
										</div>
										<div className="clear"></div>
									</div>
								);
							} else {
								bundle = (
									<div className="row">
										<div className="col l">Internet:</div>
										<div className="col r">
											{itm.bundle === "99999999" ? "Unlimited" : itm.bundle}{" "}
											{itm.bundleMeasUnit}{" "}
											{data.data.data.data.type === "OTE_TV"
												? " για COSMOTE TV GO"
												: ""}
										</div>
										<div className="clear"></div>
									</div>
								);
							}
						} else {
							if (data.data.data.data.modal.type === "PLAY") {
								bundle = (
									<div className="row">
										<div className="col l">Streaming:</div>
										<div className="col r">
											{itm.bundle === "99999999" ? "Unlimited" : itm.bundle}{" "}
											{itm.bundleMeasUnit}{" "}
											{data.data.data.data.type === "OTE_TV"
												? " για COSMOTE TV GO"
												: ""}
										</div>
										<div className="clear"></div>
									</div>
								);
							} else {
								bundle = (
									<div className="row">
										<div className="col l">Internet:</div>
										<div className="col r">
											{itm.bundle === "99999999" ? "Unlimited" : itm.bundle}{" "}
											{itm.bundleMeasUnit}{" "}
											{data.data.data.data.type === "OTE_TV"
												? " για COSMOTE TV GO"
												: ""}
										</div>
										<div className="clear"></div>
									</div>
								);
							}
						}
					}

					if (
						data.data.data.data.modal.type === "IMP" ||
						data.data.data.data.modal.type === "SMS_INTERNET" ||
						data.data.data.data.modal.type === "VOICE_INTERNET"
					) {
						if (summerOfferFlag) {
							bundle = (
								<div className="row">
									<div className="col l">Δώρο:</div>
									<div className="col r">
										{data.data.data.data.summerOfferAmount}
									</div>
									<div className="clear"></div>
								</div>
							);
						}
					}

					if (itm.type === "SMS") {
						if (textSMS !== "") {
							textSMS += " & ";
						}
						textSMS += itm.bundle;
						if (itm.destination === "TO_NATIONAL_DESTINATIONS") {
							if (UserType === "PREPAID_FROG") {
								textSMS += " προς εθνικά δίκτυα";
							} else {
								textSMS += " προς όλους";
							}
						} else if (itm.destination === "TO_COSMOTE") {
							textSMS += " προς COSMOTE";
						} else if (itm.destination === "TO_INTERNATIONAL") {
							textSMS += " προς διεθνείς προορισμούς";
						} else if (itm.destination === "TO_WHATS_UP") {
							textSMS += " προς What's Up";
						} else if (itm.destination === "TO_FROG") {
							textSMS += " προς FROG";
						}
					} else if (itm.type === "Voice") {
						if (textMin !== "") {
							textMin += " & ";
						}
						textMin += itm.bundle === "99999999" ? "Απεριόριστα" : itm.bundle;
						// textMin += itm.bundle;
						if (itm.destination === "TO_NATIONAL_DESTINATIONS") {
							if (UserType === "PREPAID_FROG") {
								textMin += " προς εθνικά δίκτυα";
							} else {
								textMin += " προς όλους";
							}
						} else if (itm.destination === "TO_COSMOTE") {
							textMin += " προς COSMOTE";
						} else if (itm.destination === "TO_INTERNATIONAL") {
							textMin += " προς διεθνείς προορισμούς";
						} else if (itm.destination === "TO_WHATS_UP") {
							textMin += " προς What's Up";
						} else if (itm.destination === "TO_FROG") {
							textMin += " προς FROG";
						}
					}
				}
			});
			if (bundle !== "") {
				output.push(bundle);
			}
			if (textSMS !== "") {
				output.push(
					<div className="row">
						<div className="col l">SMS:</div>
						<div
							className={
								data.data.data.data.modal.servicePurchaseMethodUIFormat ===
								"MANY_PURCHASE_TYPES"
									? "col r max-text customClassDetailsSMSRow"
									: "col r max-text customClasslightboxSMStoDestinationRow"
							}>
							{textSMS}
						</div>
						<div className="clear"></div>
					</div>,
				);
			}
			if (textMin !== "") {
				output.push(
					<div className="row">
						<div className="col l">Ομιλία:</div>
						<div
							className={
								data.data.data.data.modal.servicePurchaseMethodUIFormat ===
								"MANY_PURCHASE_TYPES"
									? "col r max-text customClassDetailsVoiceRow"
									: "col r max-text customClasslightboxVoicetoDestinationRow"
							}>
							{textMin}
						</div>
						<div className="clear"></div>
					</div>,
				);
			}
			if (
				data.data.data.data.modal.servicePurchaseMethodUIFormat ===
					"ONLY_ONE_PURCHASE_TYPE_BLNC" &&
				doesTheCurrentLoopServiceHasPopUp
			) {
				if (
					data.data.data.data.modal.type === "WEEKEND" ||
					data.data.data.data.modal.type === "PROMO"
				) {
					if (sessionStorage.getItem("hasPromoGigaActive")) {
						output.push(
							<div className="row">
								<div className="col l">Διάρκεια:</div>
								<div className="col r">
									{data.data.data.data.modal.type === "WEEKEND"
										? "Παρ.18:00-Δευτ.23:59"
										: data.data.data.data.modal.period +
											" " +
											data.data.data.data.modal.tariffMeasunitTeaserFormated}
								</div>
								<div className="clear"></div>
							</div>,
						);
					} else {
						output.push(
							<div className="row">
								<div className="col l">Διάρκεια:</div>
								<div className="col r">
									{data.data.data.data.modal.type === "WEEKEND"
										? "Παρ.18:00-Κυρ.23:59"
										: data.data.data.data.modal.period +
											" " +
											data.data.data.data.modal.tariffMeasunitTeaserFormated}
								</div>
								<div className="clear"></div>
							</div>,
						);
					}
				}
			} else if (
				data.data.data.data.modal.servicePurchaseMethodUIFormat ===
					"MANY_PURCHASE_TYPES" &&
				doesTheCurrentLoopServiceHasPopUp
			) {
				if (
					UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
					data.data.data.data.modal.type === "WEEKEND"
				) {
					output.push(
						<div className="row">
							<div className="col l">Χρέωση:</div>
							<div className="col r">
								{data.data.data.data.modal.tariff == "0"
									? "Δωρεάν"
									: data.data.data.data.modal.tariff + "&euro;"}
							</div>
							<div className="clear"></div>
						</div>,
					);
				} else if (
					data.data.data.data.modal.type === "PLAY" &&
					sessionStorage.getItem("hasPromoGigaActive")
				) {
					output.push(
						<div className="row">
							<div className="col l">Χρέωση:</div>
							<div className="col r">
								Προσφορά {data.data.data.data.modal.tariff}€
							</div>
							<div className="clear"></div>
						</div>,
					);
				} else if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
					if (
						data.data.data.data.modal.type === "PLAY" &&
						sessionStorage.getItem("hasPromoGigaActive")
					) {
						output.push(
							<div className="row">
								<div className="col l">Χρέωση:</div>
								<div className="col r">
									Προσφορά {data.data.data.data.modal.tariff}€
								</div>
								<div className="clear"></div>
							</div>,
						);
					}
				} else {
					output.push(
						<div className="row">
							<div className="col l">Χρέωση:</div>
							<div className="col r">{data.data.data.data.modal.tariff}€</div>
							<div className="clear"></div>
						</div>,
					);
				}
				if (
					(UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ||
						UserType === "HYBRID_BUSINESS_COST_CONTROL") &&
					data.data.data.data.modal.type === "WEEKEND"
				) {
					if (sessionStorage.getItem("hasPromoGigaActive")) {
						output.push(
							<div className="row">
								<div className="col l">Διάρκεια:</div>
								<div className="col r">
									{data.data.data.data.modal.type === "WEEKEND"
										? "Παρ.18:00-Δευτ.23:59"
										: data.data.data.data.modal.period +
											" " +
											data.data.data.data.modal.tariffMeasunitTeaserFormated}
								</div>
								<div className="clear"></div>
							</div>,
						);
					} else {
						output.push(
							<div className="row">
								<div className="col l">Διάρκεια:</div>
								<div className="col r">
									{data.data.data.data.modal.type === "WEEKEND"
										? "Παρ.18:00-Κυρ.23:59"
										: data.data.data.data.modal.period +
											" " +
											data.data.data.data.modal.tariffMeasunitTeaserFormated}
								</div>
								<div className="clear"></div>
							</div>,
						);
					}
				} else {
					output.push(
						<div className="row">
							<div className="col l">Διάρκεια:</div>
							<div className="col r">
								{data.data.data.data.modal.type === "WEEKEND"
									? "Παρ.18:00-Κυρ.23:59"
									: data.data.data.data.modal.period +
										" " +
										data.data.data.data.modal.tariffMeasunitTeaserFormated}
							</div>
							<div className="clear"></div>
						</div>,
					);
				}
			}
		}
	}

	return output;
}

function titleForEachPackagePopUp(data, templateComponent) {
	let text = "";
	let UserType = Functions["custom"]["getUserType"]();
	let landPageData = JSON.parse(sessionStorage.landPageData);
	let newData = data.data.data.data;
	let hasPromoGigaActive = sessionStorage.getItem("hasPromoGigaActive");
	let durationUnit =
		newData.periodMeasunit ||
		newData.tariffMeasunitTeaserFormated ||
		(newData.modal && newData.modal.tariffMeasunitTeaserFormated) ||
		"";
	let duration =
		newData.type === "WEEKEND"
			? "Παρ.18:00-Κυρ.23:59"
			: newData.period + (durationUnit ? " " + durationUnit : "");
	let hasActiveImp = sessionStorage.getItem("hasActiveImp");
	let activeImpDesc = sessionStorage.getItem("activeImpDesc");
	let hasPromoPlayNowUnActive = sessionStorage.getItem(
		"hasPromoPlayNowUnActive",
	);
	let hideButton = false;
	sessionStorage.setItem("hideButton", JSON.stringify(hideButton));
	sessionStorage.setItem("link", "/thank_you");
	sessionStorage.setItem("deactivationPackage", "false");

	let isChecked = false;

	if (newData.type === "VOLUME_CHARGE") {
		text = (
			<h2>
				Έχετε επιλέξει να χρεώνεστε ανά ΜΒ:
				<br /> {newData.tariff}
			</h2>
		);
	} else if (newData.type === "WEEKEND") {
		if ((newData.tariff = "0")) {
			if (hasPromoGigaActive === "true") {
				text = (
					<div>
						<h2>
							{newData.bundle}
							{newData.bundleMeasUnit} για το ΣΚ & Δευτέρα,
							<br /> ΕΝΤΕΛΩΣ ΔΩΡΕΑΝ
						</h2>
						<div className="tip">
							<div className="tip-title">
								<img src="/resources/images/icon-tip.png" /> Tip:{" "}
							</div>
							Μπείτε και ενεργοποιείστε την προσφορά κάθε εβδομάδα, έως και
							04/06/2017
						</div>
					</div>
				);
			} else {
				text = (
					<div>
						<h2>
							{newData.bundle}
							{newData.bundleMeasUnit} για το ΣΚ,
							<br /> ΕΝΤΕΛΩΣ ΔΩΡΕΑΝ
						</h2>
						<div className="tip">
							<div className="tip-title">
								<img src="/resources/images/icon-tip.png" /> Tip:{" "}
							</div>
							Μπείτε και ενεργοποιείστε την προσφορά κάθε εβδομάδα, έως και
							04/06/2017
						</div>
					</div>
				);
			}
		} else {
			if (hasPromoGigaActive === "true") {
				text = (
					<div>
						<h2>
							Έχετε επιλέξει{" "}
							{newData.bundle === "99999999" ? " Απεριόριστα " : newData.bundle}{" "}
							{newData.bundleMeasUnit} για ΣΚ & Δευτέρα,
							<br />
							μόνο με {newData.tariff}€
						</h2>
						<div className="tip">
							<div className="tip-title">
								<img src="/resources/images/icon-tip.png" /> Tip:{" "}
							</div>
							Μπορείτε να καταναλώνετε{" "}
							{newData.bundle === "99999999"
								? " Απεριόριστα "
								: "τα " + newData.bundle}
							{newData.bundleMeasUnit} από Παρασκευή 18:00 έως Δευτέρα 24:00.
						</div>
					</div>
				);
			} else {
				text = (
					<div>
						<h2>
							Έχετε επιλέξει{" "}
							{newData.bundle === "99999999" ? " Απεριόριστα " : newData.bundle}{" "}
							{newData.bundleMeasUnit} για το Σαββατοκύριακο, με
							<br /> μόνο με {newData.tariff}€
						</h2>
						<div className="tip">
							<div className="tip-title">
								<img src="/resources/images/icon-tip.png" /> Tip:{" "}
							</div>
							Μπορείτε να καταναλώνετε{" "}
							{newData.bundle === "99999999"
								? " Απεριόριστα "
								: "τα " + newData.bundle}
							{newData.bundleMeasUnit} από Παρασκευή 18:00 έως Κυριακή 24:00.
						</div>
					</div>
				);
			}
		}
	} else if (newData.type === "HOURS") {
		text = (
			<h2>
				Έχετε επιλέξει{" "}
				{newData.bundle === "99999999"
					? " Απεριόριστα Data "
					: newData.bundle + newData.bundleMeasUnit}{" "}
				<br /> για {duration}, με {newData.tariff}€
			</h2>
		);
	} else if (
		newData.type === "EXTRA" ||
		newData.type === "IMP" ||
		newData.type === "OTE_TV"
	) {
		if (newData.type === "OTE_TV") {
			text = (
				<h2>
					Έχετε επιλέξει
					<br />
					COSMOTE TV GO {newData.bundle}
					{newData.bundleMeasUnit}
					<br /> για {duration}, με {newData.tariff}€
				</h2>
			);
		} else {
			if (newData.type === "IMP") {
				if (newData.active) {
					sessionStorage.setItem("deactivationPackage", "true");
					text = (
						<h2>
							Επέλεξες να <br />
							απενεργοποιήσεις το {newData.busServiceDes}
						</h2>
					);
				} else {
					if (hasActiveImp === "false") {
						if (!newData.inValidBillCycle) {
							hideButton = true;
							sessionStorage.setItem("hideButton", JSON.stringify(hideButton));
							text = (
								<h2>
									Δεν μπορείς να κάνεις άλλη ενεργοποίηση μέσα στον ίδιο
									τιμολογιακό κύκλο. Θα μπορείς να ενεργοποιήσεις κάποιο πακέτο
									μετά τις {newData.billingDate}
								</h2>
							);
						} else {
							if (
								JSON.parse(sessionStorage.getItem("residential")).indexOf(
									UserType,
								) === -1
							) {
								if (UserType === "POSTB") {
									text = (
										<h2>
											Επέλεξες το πακέτο {newData.busServiceDes},<br />
											που τώρα σου δίνει τα διπλάσια GB κάθε μήνα, για πάντα, με
											αυτόματη ανανέωση μόνο με {newData.tariff}€/Μήνα
										</h2>
									);
								} else {
									text = (
										<h2>
											Επέλεξες να ενεργοποιήσεις το {newData.busServiceDes},
											<br />
											που τώρα σου δίνει τα διπλάσια GB κάθε μήνα, για πάντα, με
											αυτόματη ανανέωση μόνο με {newData.tariff}€/Μήνα
										</h2>
									);
								}
							} else {
								text = (
									<h2>
										Επέλεξες {newData.bundle}
										{newData.bundleMeasUnit},<br />
										με αυτόματη ανανέωση μόνο με {newData.tariff}€/Μήνα
									</h2>
								);
							}
						}
					} else if (hasActiveImp === "true") {
						if (newData.inValidBillCycle) {
							text = (
								<h2>
									Επέλεξες να ενεργοποιήσεις το {newData.busServiceDes},<br />{" "}
									και να απενεργοποιήσεις το ενεργό {activeImpDesc}
								</h2>
							);
						} else {
							hideButton = true;
							sessionStorage.setItem("hideButton", JSON.stringify(hideButton));
							text = (
								<h2>
									Δεν μπορείς να κάνεις άλλη ενεργοποίηση μέσα στον ίδιο
									τιμολογιακό κύκλο. Θα μπορείς να ενεργοποιήσεις κάποιο πακέτο
									μετά τις {newData.billingDate}
								</h2>
							);
						}
					}
				}
			} else {
				if (
					newData.impAddOn.data !== null &&
					newData.impAddOn.dataMeasuringUnit !== null
				) {
					text = (
						<div>
							<h2 className="title-tip">
								Έχετε επιλέξει {newData.bundle}
								{newData.bundleMeasUnit} για τις επόμενες {duration}, με{" "}
								{newData.tariff}€
							</h2>
							<div>
								<div className="tip">
									<div className="tip-title">
										<img
											src="/resources/images/icon-tip.png"
											align="absmiddle"
										/>{" "}
										Tip:
									</div>
									Στην ίδια τιμή μπορείτε να αποκτήσετε το πακέτο{" "}
									{newData.impAddOn.busServiceDesc} με αυτόματη ανανέωση κάθε
									μήνα. Επιλέξτε:
								</div>
								<div className="package-options">
									<span
										service-id={newData.impAddOn.jointServiceId}
										className="option "
										onClick={() => {
											sessionStorage.setItem(
												"id",
												newData.impAddOn.jointServiceId,
											);
											isChecked = true;
											let d = document.getElementsByClassName("option")[0];
											let c = document.getElementsByClassName("option")[1];
											let titleTip =
												document.getElementsByClassName("title-tip")[0];
											let tip = document.getElementsByClassName("tip")[0];
											let impAddOnSelected =
												"Έχετε επιλέξει το πακέτο " +
												newData.impAddOn.busServiceDesc +
												", με αυτόματη ανανέωση κάθε μήνα, που τώρα δίνει τα διπλάσια GB για πάντα, μόνο με " +
												newData.impAddOn.price +
												"€/μήνα";
											let iconChanges =
												newData.impAddOn.data +
												"<br/>" +
												newData.impAddOn.dataMeasuringUnit;
											let icon =
												document.getElementsByClassName("icon")[
													document.getElementsByClassName("icon").length - 1
												];
											let copyInfo =
												document.getElementsByClassName("copy-info")[0];
											let inValidBillCycle = newData.impAddOn.inValidBillCycle;
											if (isChecked) {
												d.className += " active";
												c.className = "option ";
												tip.style.display = "none";
												if (inValidBillCycle) {
													titleTip.innerHTML = impAddOnSelected;
													copyInfo.innerHTML =
														'Τα GB του πακέτου ανανεώνονται κάθε μήνα μαζί με το πρόγραμμά σου και μπορούν να μοιραστούν και σε επιπλέον συσκευές. Η προσφορά "ΔΙΠΛΑΣΙΑ GB" ισχύει για πάντα.';
												} else {
													hideButton = true;
													sessionStorage.setItem(
														"hideButton",
														JSON.stringify(hideButton),
													);
													titleTip.innerHTML = "";
													copyInfo.innerHTML =
														"Δεν μπορείς να κάνεις άλλη ενεργοποίηση μέσα στον ίδιο\n" +
														"                  τιμολογιακό κύκλο. Θα μπορείς να ενεργοποιήσεις κάποιο πακέτο\n" +
														"                  μετά τις " +
														newData.billingDate;
												}

												icon.className = "icon";
												icon.innerHTML = iconChanges;
												templateComponent.setState({
													link: "/thank_you",
												});
												// window["modal"].setState({ link: "/thank_you" });
												isChecked = false;
											} else {
												c.className = "option ";
												d.className += " active";
												tip.style.display = "block";
												if (newData.type === "PROMO") {
													icon.className = "icon iconpromo";
												} else if (
													(newData.type === "EXTRA" ||
														newData.type === "GIGA_SUMMER") &&
													UserType !== "PREPAID_FROG"
												) {
													icon.className = "icon iconsummer";
												}
												//icon.className =
												// document.getElementsByClassName('icon')[document.getElementsByClassName('icon').length -1];
												isChecked = true;
											}
										}}>
										<input
											type="radio"
											name="package-option"
											// checked={isChecked}
										/>
										<div className="option-title">
											{" "}
											{newData.impAddOn.data}{" "}
											{newData.impAddOn.dataMeasuringUnit}
										</div>
										με αυτόματη ανανέωση κάθε μήνα{" "}
										<span style={{ cursor: "pointer" }}></span>
									</span>
									<span
										service-id={newData.impAddOn.jointServiceId}
										className="option active"
										onClick={() => {
											sessionStorage.setItem("link", "/creditSubmitService");
											sessionStorage.setItem("id", data.data.value.jointID);
											let a = document.getElementById("anchor");

											a.setAttribute("href", sessionStorage.getItem("link"));
											isChecked = true;
											let d = document.getElementsByClassName("option")[1];
											let c = document.getElementsByClassName("option")[0];
											let titleTip =
												document.getElementsByClassName("title-tip")[0];
											let tip = document.getElementsByClassName("tip")[0];
											let impAddOnSelected =
												"Έχετε επιλέξει το πακέτο " +
												newData.impAddOn.busServiceDesc +
												", με αυτόματη ανανέωση κάθε μήνα, που τώρα δίνει τα διπλάσια GB για πάντα, μόνο με " +
												newData.impAddOn.price +
												"€/μήνα";
											let iconChanges =
												newData.impAddOn.data +
												"<br/>" +
												newData.impAddOn.dataMeasuringUnit;
											let icon =
												document.getElementsByClassName("icon")[
													document.getElementsByClassName("icon").length - 1
												];
											let copyInfo =
												document.getElementsByClassName("copy-info")[0];

											if (isChecked) {
												d.className += " active";
												c.className = "option ";
												tip.style.display = "block";
												if (newData.type === "PROMO") {
													icon.className = "icon iconpromo";
												} else if (
													(newData.type === "EXTRA" ||
														newData.type === "GIGA_SUMMER") &&
													UserType !== "PREPAID_FROG"
												) {
													icon.className = "icon iconsummer";
												}
												icon.innerHTML = "";
												titleTip.innerHTML =
													"Έχετε επιλέξει " +
													newData.bundle +
													newData.bundleMeasUnit +
													" για τις επόμενες " +
													duration +
													", με " +
													newData.tariff +
													"€";
												copyInfo.innerHTML = textUnderPackages(data);
												templateComponent.setState({
													link: "/creditSubmitService",
												});
												// window["modal"].setState({
												//   link: "/creditSubmitService",
												// });
												isChecked = false;
											} else {
												c.className = "option ";
												d.className += " active";
												tip.style.display = "block";
												icon.className =
													document.getElementsByClassName("icon")[
														document.getElementsByClassName("icon").length - 1
													];
												icon.innerHTML = "";
												isChecked = true;
											}
										}}>
										<input
											type="radio"
											name="package-option"
											// checked={isChecked}
										/>
										<div className="option-title">
											{newData.bundle} {newData.bundleMeasUnit}
										</div>
										για τις επόμενες {duration}{" "}
										<span style={{ cursor: "pointer" }}></span>
									</span>
								</div>
							</div>
						</div>
					);
				} else {
					text = (
						<h2>
							Έχετε επιλέξει {newData.bundle}
							{newData.bundleMeasUnit} <br /> για {duration}, με{" "}
							{newData.tariff}€
						</h2>
					);
				}
			}
		}
		if (newData.summerOfferActive && landPageData.summerOfferState) {
			text = <h2>Δώρο:Επιπλέον {newData.summerOfferAmount}</h2>;
		}
	} else if (newData.type === "DAY_PASS") {
		text = (
			<div>
				<h2>
					Έχετε επιλέξει{" "}
					{newData.bundle === "99999999"
						? " Απεριόριστα Data "
						: newData.bundle + newData.bundleMeasUnit}{" "}
					<br />
					για {duration}
				</h2>
				<div className="tip">
					<div className="tip-title">
						<img src="/resources/images/icon-tip.png" /> Tip:
					</div>
					Εφόσον καταναλωθούν τα διαθέσιμα MB, για το υπόλοιπο της διάρκειας του
					πακέτου, εφαρμόζεται πολιτική ορθής χρήσης με μείωση της ταχύτητας
					πλοήγησης
				</div>
			</div>
		);
	} else if (newData.type === "GIGA_WEEK") {
		text = (
			<h2>
				Έχετε επιλέξει{" "}
				{newData.bundle === "99999999"
					? " Απεριόριστα Data "
					: newData.bundle + newData.bundleMeasUnit}{" "}
				<br /> για {duration}, με {newData.tariff}€
			</h2>
		);
	} else if (newData.type === "GIGA_SUMMER") {
		text = (
			<h2>
				H πιο δυνατή προσφορά <br />
				του καλοκαιριού είναι εδώ <br />
				και σε περιμένει!'
				<br />
				Ενεργοποίησε το
				<br />
				GIGA NOW Summer
				<br />
				με {newData.bundle}
				{newData.bundleMeasUnit}
				<br />
				για 1 μήνα,
				<br />
				μόνο με {newData.tariff}€ !
			</h2>
		);
	} else if (newData.type === "PLAY") {
		if (hasPromoPlayNowUnActive === "true") {
			text = (
				<div>
					Έχετε επιλέξει το πακέτο {newData.busServiceDes}
					<br /> για {newData.bundle === "99999999" ? "απεριόριστα " : " "}Video
					και Music streaming με προσφορά {newData.tariff}€ για τους πρώτους 3
					μήνες!
				</div>
			);
		} else {
			text = (
				<h2>
					Έχετε επιλέξει το πακέτο {newData.busServiceDes}
					<br /> με μηνιαίο πάγιο {newData.tariff}€ για{" "}
					{newData.bundle === "99999999" ? "απεριόριστα " : " "}Video και Music
					streaming
				</h2>
			);
		}
	} else if (newData.type === "PROMO") {
		text = (
			<h2>
				Έχετε επιλέξει Απεριόριστα Data <br />
				για {duration}
			</h2>
		);
	} else {
		text = <h2>Έχετε επιλέξει το πακέτο ' + newData.busServiceDes</h2>;
	}

	return text;
}

function textUnderPackages(data) {
	let UserType = Functions["custom"]["getUserType"]();
	let landPageData = JSON.parse(sessionStorage.landPageData);
	let newData = data.data.data.data;
	let imp = sessionStorage.getItem("imp");
	let hasPromoPlayNowUnActive = sessionStorage.getItem(
		"hasPromoPlayNowUnActive",
	);
	let text = "";

	if (newData.type === "IMP") {
		if (newData.active) {
			text = "Η απενεργοποίηση γίνεται άμεσα και χάνετε τα υπολειπόμενα MB";
		} else {
			if (imp !== "true") {
				if (newData.inValidBillCycle) {
					if (
						JSON.parse(sessionStorage.getItem("residential")).indexOf(
							UserType,
						) === -1
					) {
						text =
							'Τα GB του πακέτου ανανεώνονται κάθε μήνα μαζί με το πρόγραμμά σου και μπορούν να μοιραστούν και σε επιπλέον συσκευές. Η προσφορά "ΔΙΠΛΑΣΙΑ GB" ισχύει για πάντα.';
					} else {
						text =
							"Τα GB του πακέτου ανανεώνονται κάθε μήνα μαζί με το πρόγραμμά σου και μπορούν να μοιραστούν και σε επιπλέον συσκευές.";
					}
				}
			} else if (newData.inValidBillCycle) {
				text =
					"H απενεργοποίηση του ενεργού σου πακέτου και ενεργοποίηση του νέου γίνεται άμεσα και αποδίδεται το σύνολο των GB του νέου πακέτου.";
			}
		}
	} else if (newData.type === "HOURS") {
		text =
			"Τo πακέτο ισχύει για 24 ώρες και μπορεί να καταναλωθεί σε Ε.Ε. (ισχύει όριο ορθής χρήσης 3 GB).Το πακέτο δεν μοιράζεται και σε επιπλέον συσκευές.";
	} else if (newData.type === "PROMO") {
		text =
			"Το πακέτο μπορεί να καταναλωθεί και σε Ε.Ε. με όριο 11,5 GB και δεν μοιράζεται σε επιπλέον συσκευές";
	} else if (newData.type === "GIGA_WEEK") {
		text =
			"Το πακέτο ισχύει για 7 ημέρες, μπορεί να καταναλωθεί σε Ε.Ε. (ισχύει όριο ορθής χρήσης 8 GB) Το πακέτο δεν μοιράζεται και σε επιπλέον συσκευές.";
	} else if (newData.type === "VOLUME_CHARGE") {
		text = "";
	} else if (newData.type === "PLAY") {
		if (hasPromoPlayNowUnActive) {
			text =
				"Η υπηρεσία ανανεώνεται αυτόματα κάθε μήνα και είναι διαθέσιμη μόνο από αυτή τη σύνδεση. Μετά τους πρώτους 3 μήνες το μηνιαίο πάγιο επανέρχεται στα 15€. Για να χρησιμοποιήσετε το πακέτο χρειάζεται να έχετε διαθέσιμα ΜΒ στο πρόγραμμά σας για γενική χρήση Internet.";
		} else {
			text =
				"Η υπηρεσία ανανεώνεται αυτόματα κάθε μήνα και είναι διαθέσιμη μόνο από αυτή τη σύνδεση. Για να χρησιμοποιήσετε το πακέτο χρειάζεται να έχετε διαθέσιμα ΜΒ στο πρόγραμμά σας για γενική χρήση Internet";
		}
	} else if (newData.type === "EXTRA" || newData.type === "OTE_TV") {
		text =
			"Τo πακέτο ισχύει για 30 ημέρες, μπορεί να καταναλωθεί σε Ε.Ε. και μοιράζεται και σε επιπλέον συσκευές.";
	} else {
		text = "";
	}
	//if is Whatsup do not display text
	if (landPageData.prepaidWu) text = "";
	return text;
}

const ModalForPackages = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					data: { data: [] },
					replace: {},
					mapper: Mapper,
				},
			},
			template: "plain",
			templateConfiguration: {
				cardTopTemplate: function () {
					let UserType = Functions["custom"]["getUserType"]();
					let data = this.state.data[0];
					let landPageData = JSON.parse(sessionStorage.landPageData);
					let _this = this;
					if (sessionStorage.pendingStatus === "PENDING") {
						let classNameDiv = "";
						let classNameA = "";
						let id = "";
						let h2text = "";
						let h3text = "";
						let lotsBr = false;
						if (UserType === "PREPAID_FROG") {
							classNameDiv =
								"lightbox customClassWarning customClassWarningFrog customClassPendingRequest";
							h2text = (
								<h2>
									Σε ενημερώνουμε ότι υπάρχει <br /> προηγούμενο αίτημά σε
									εξέλιξη. <br />
									Θα ενημερωθείς για την εξέλιξη του αιτήματός σου με γραπτό
									μήνυμα
								</h2>
							);
							classNameA = "cancel customClassAddCursorPointer";
						} else if (UserType === "PREPAID_WHATSUP") {
							classNameDiv =
								"lightbox customClassWarning customClassWarningWhatsUp customClassPendingRequest";
							h2text = <h2>Ενημέρωση</h2>;
							h3text = (
								<h3>
									Σε ενημερώνουμε ότι υπάρχει <br /> προηγούμενο αίτημά σε
									εξέλιξη. <br />
									Θα ενημερωθείς για την εξέλιξη του αιτήματός σου με γραπτό
									μήνυμα
								</h3>
							);
							classNameA = "cancel customClassAddCursorPointer";
						} else if (UserType === "PREPAID_COSMOKARTA") {
							classNameDiv =
								"lightbox customClassWarning customClassPendingRequest";
							h2text = (
								<h2>
									Σε ενημερώνουμε ότι υπάρχει <br /> προηγούμενο αίτημά σε
									εξέλιξη. <br />
									Θα ενημερωθείς για την εξέλιξη του αιτήματός σου με γραπτό
									μήνυμα
								</h2>
							);
							classNameA = "cancel customClassAddCursorPointer";
						} else if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
							classNameDiv =
								"lightbox customClassWarning customClassPendingRequest";
							h2text = (
								<h2>
									Σας ενημερώνουμε ότι υπάρχει <br /> προηγούμενο αίτημά σε
									εξέλιξη. <br />
									Θα ενημερωθείτε για την εξέλιξη του αιτήματός σας με γραπτό
									μήνυμα
								</h2>
							);
							classNameA = "cancel customClassAddCursorPointer";
						} else if (UserType === "HYBRID_RESIDENTIAL_COST_CONTROL") {
							classNameDiv =
								"lightbox customClassWarning customClassPendingRequest";
							h2text = (
								<h2>
									Σε ενημερώνουμε ότι υπάρχει <br /> προηγούμενο αίτημά σε
									εξέλιξη. <br />
									Θα ενημερωθείς για την εξέλιξη του αιτήματός σου με γραπτό
									μήνυμα
								</h2>
							);
							classNameA = "cancel customClassAddCursorPointer";
						} else {
							lotsBr = true;
							classNameDiv = "lightbox";
							id = "warningsServiceOnProgress";
							h2text = (
								<h2>
									Σας ενημερώνουμε ότι υπάρχει <br /> προηγούμενο αίτημά σε
									εξέλιξη. <br />
									Θα ενημερωθείτε για την εξέλιξη του αιτήματός σας με γραπτό
									μήνυμα
								</h2>
							);
							classNameA = "cancel customClassAddCursorPointer";
						}
						return (
							<div
								className={classNameDiv}
								id={id}
								style={{ display: "block", overflow: "hidden" }}>
								<div className="content">
									<div className="deactivation-icon"></div>
									{lotsBr && (
										<>
											{" "}
											<br />
											<br />
											<br />
											<br />
											<br />
										</>
									)}
									{h2text}
									{h3text !== "" && h3text}
									<a
										onClick={() => {
											window["modal"].setState({ show: false });
										}}
										className={classNameA}>
										Επιστροφή
									</a>
								</div>
							</div>
						);
					}
					if (data.data.value.type === "VOLUME_CHARGE") {
						sessionStorage.setItem("id", "ROR");
					} else {
						if (
							data.data.data.data.impAddOn !== undefined &&
							sessionStorage.getItem("id") ===
								data.data.data.data.impAddOn.jointServiceId
						) {
							sessionStorage.setItem(
								"id",
								data.data.data.data.impAddOn.jointServiceId,
							);
						} else {
							sessionStorage.setItem("id", data.data.value.jointID);
						}
					}
					sessionStorage.setItem(
						"modalData",
						JSON.stringify(data.data.data.data),
					);
					if (
						UserType === "POSTR" ||
						UserType === "POSTB" ||
						UserType === "POSTB_SPLIT"
					) {
						sessionStorage.setItem(
							"pt",
							data.data.value.purchaseOptions.purchaseType,
						);
					} else {
						sessionStorage.setItem("pt", data.data.value.pt);
					}

					const usesPostpaidModal =
						UserType === "POSTR" ||
						UserType === "POSTB" ||
						UserType === "POSTB_SPLIT" ||
						UserType === "PREPAID_COSMOKARTA";

					let icon = "";
					let dataType = data.data.value.type;
					if (dataType === "PROMO")
						icon = (
							<div
								className={
									usesPostpaidModal
										? "icon iconpromo"
										: (UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
													landPageData.contractInfoCarrier
														.inListOfWhatuspCss) ||
											  UserType === "PREPAID_WHATSUP"
											? "icon promocosmo promowu"
											: "icon promocosmo cosmo"
								}></div>
						);
					else if (
						(dataType === "EXTRA" || dataType === "GIGA_SUMMER") &&
						UserType !== "PREPAID_FROG"
					) {
						icon = <div className="icon iconsummer"></div>;
					} else if (dataType === "EXTRA" && UserType === "PREPAID_FROG") {
						let numberOfGB = "";
						for (let i = 0; i < data.data.value.offerList.length; i++) {
							if (data.data.value.offerList[i].bundleMeasUnit === "GB")
								numberOfGB = data.data.value.offerList[i].bundle;
						}
						icon = icon = (
							<div className="icon frog">
								{numberOfGB}
								<br />
								GB
							</div>
						);
					} else if (dataType === "GIGA_WEEK")
						icon = (
							<div
								className={
									UserType === "PREPAID_FROG"
										? "icon iconweek frog"
										: "icon iconweek"
								}></div>
						);
					else if (dataType === "HOURS")
						icon = (
							<div
								className={
									UserType === "PREPAID_FROG"
										? "icon iconhourpass frog"
										: " icon iconhourpass"
								}></div>
						);
					else if (dataType === "IMP")
						icon =
							UserType === "PREPAID_FROG" ? (
								<div className="icon frog">
									{data.data.value.bundle}
									<br />
									GB
								</div>
							) : (
								<div className="icon icongb">
									<span className="icon-gb-value">
										{data.data.value.bundle}
									</span>
									<span className="icon-gb-unit">GB</span>
								</div>
							);
					else if (dataType === "COMBO")
						icon = <div className="icon combo"></div>;
					else if (dataType === "VOICE_INTERNET")
						icon = <div className="icon minmb"></div>;
					else if (dataType === "WEEKEND")
						icon = (
							<div
								className={
									UserType === "PREPAID_FROG"
										? "icon iconweekend frog"
										: "icon iconweekend"
								}></div>
						);
					else icon = <div className=""></div>;
					if (!usesPostpaidModal)
						return (
							<div
								id="select-package"
								className={
									UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
									landPageData.contractInfoCarrier.inListOfWhatuspCss
										? "lightbox customGeneralClasslightbox"
										: "lightbox products-with-tips customGeneralClasslightbox"
								}
								style={{ display: "block", overflow: "overlay" }}>
								<div
									className="content contentmodal"
									style={
										UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
										landPageData.contractInfoCarrier.inListOfWhatuspCss
											? { height: "auto" }
											: null
									}>
									<div className="package-cyrcle">{icon} </div>
									{UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" ||
									UserType === "HYBRID_BUSINESS_COST_CONTROL" ? (
										<h2
											className={
												dataType === "VOICE_INTERNET" ||
												dataType === "SMS_INTERNET" ||
												(dataType === "COMBO" &&
													UserType === "PREPAID_COSMOKARTA")
													? "min"
													: ""
											}>
											Έχεις επιλέξει να <br />
											ενεργοποιήσεις το πακέτο
										</h2>
									) : (
										<h2
											className={
												dataType === "VOICE_INTERNET" ||
												dataType === "SMS_INTERNET" ||
												(dataType === "COMBO" &&
													UserType === "PREPAID_COSMOKARTA")
													? "min"
													: ""
											}>
											Έχεις επιλέξει το πακέτο
										</h2>
									)}
									<h3
										className={
											dataType === "VOICE_INTERNET" ||
											dataType === "SMS_INTERNET" ||
											(dataType === "COMBO" &&
												UserType === "PREPAID_COSMOKARTA")
												? "min"
												: ""
										}>
										{data.data.value.busServiceDes}
									</h3>
									<h4
										className={
											(dataType === "GIGA_WEEK" &&
												UserType === "HYBRID_RESIDENTIAL_COST_CONTROL") ||
											(dataType === "COMBO" &&
												UserType === "PREPAID_COSMOKARTA") ||
											dataType === "SMS_INTERNET" ||
											dataType === "VOICE_INTERNET" ||
											(dataType === "GIGA_WEEK" &&
												UserType === "PREPAID_COSMOKARTA") ||
											(dataType === "GIGA_WEEK" &&
												UserType === "PREPAID_FROG") ||
											(dataType === "GIGA_WEEK" &&
												UserType === "PREPAID_WHATSUP") ||
											(dataType === "SMS_INTERNET" &&
												UserType === "PREPAID_WHATSUP") ||
											(dataType === "HOURS" && UserType === "PREPAID_FROG") ||
											(dataType === "HOURS" &&
												UserType === "PREPAID_WHATSUP") ||
											(dataType === "HOURS" &&
												UserType === "HYBRID_RESIDENTIAL_COST_CONTROL")
												? ""
												: "min"
										}>
										Περιγραφή Πακέτου
									</h4>
									<div className="package-details">
										{detailsOfBundles(data)}
									</div>
									{contentPackageOptions(data)}
									{/*{submitButton(data)}*/}
									<Link
										style={
											(data.data.data.data.modal
												.atLeastOnePurchaseTypeEligibleForPurchase &&
												UserType === "HYBRID_RESIDENTIAL_COST_CONTROL") ||
											UserType !== "HYBRID_RESIDENTIAL_COST_CONTROL"
												? { display: "block" }
												: { display: "none" }
										}
										className="submit addCursorPointer passSubmitButtonCreditFlow"
										to={submitButton(data)}
										onClick={() => {
											window["modal"].setState({ show: false });
										}}>
										Επιβεβαίωση
									</Link>
									<a
										onClick={() => {
											window["modal"].setState({ show: false });
										}}
										className="cancel customClassAddCursorPointer addCursorPointer">
										Ακύρωση &gt;
									</a>
								</div>
							</div>
						);
					else
						return (
							<div
								id="select-package"
								className="lightbox products-with-tips"
								style={{ display: "block" }}>
								<div className="content">
									<div className="package-cyrcle">{icon} </div>
									{titleForEachPackagePopUp(data, this)}
									<div className="clear"></div>
									{sessionStorage.getItem("hideButton") === null ||
									sessionStorage.getItem("hideButton") === "false" ? (
										<div className="submit-hold">
											<Link
												id="anchor"
												style={{ cursor: "pointer" }}
												className="submit passSubmitCreditFlowLimit addCursorPointer passSubmitButtonCreditFlow"
												to={
													landPageData.contractInfoCarrier.restrictionType ===
														"LIMIT_ACCESS_RESTRICTION_ONLY_HOURS_PASS" ||
													landPageData.contractInfoCarrier.restrictionType ===
														"LIMIT_ACCESS_RESTRICTION_NO_PASS"
														? "/submitPaymentInfo"
														: _this.state.link === "/thank_you" ||
															  JSON.parse(
																	sessionStorage.deactivationPackage,
															  ) ||
															  UserType === "POSTR" ||
															  UserType === "PREPAID_COSMOKARTA"
															? "/thank_you"
															: "/creditSubmitService"
												}
												onClick={() => {
													window["modal"].setState({ show: false });
													sessionStorage.setItem(
														"deactivationPackage",
														"false",
													);
													console.log(_this.state);
												}}>
												Επιβεβαίωση
											</Link>
										</div>
									) : null}
									<div className="copy-info">{textUnderPackages(data)}</div>
									<a
										style={{ cursor: "pointer" }}
										className="cancel addCursorPointer"
										onClick={() => {
											window["modal"].setState({ show: false });
										}}>
										Ακύρωση &gt;
									</a>
								</div>
							</div>
						);
				},
				includeProperties: ["none"],
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default ModalForPackages;
